var React = require('react');

function StarsInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"stars.inline"),React.createElement("g",{"id":"bef63d51-3221-40cb-8647-ddfc5efd5bcd","data-name":"Layer 2","key":1},React.createElement("g",{"id":"b4b3eb3d-eddf-4452-af8c-03519d4ba053","data-name":"Layer 1"},React.createElement("path",{"id":"e9d2d232-0992-45f5-8c85-ed454ffc70fa","data-name":"stars.inline","d":"M8.91,21.87l1.62,5.67H17l-4.86,4.05,2.43,6.48L8.91,34l-5.67,4,2.43-6.48L.81,27.54H7.29Zm21.06,0,1.62,5.67h6.48l-4.86,4.05,2.43,6.48L30,34l-5.67,4,2.43-6.48-4.86-4.05h6.48ZM19.44.81l1.62,5.67h6.48l-4.86,4L25.11,17,19.44,13,13.77,17l2.43-6.48-4.86-4h6.48Z","fill":"none","stroke":"#000","strokeLinejoin":"round","strokeWidth":"1.62"})))]);
}

StarsInline.defaultProps = {"viewBox":"0 0 38.88 38.88"};

module.exports = StarsInline;

StarsInline.default = StarsInline;
